export class SupportTicketMutationQueue {
    constructor() {
        this.tailsByTicket = new Map();
    }

    enqueue(ticketId, mutation) {
        const key = String(ticketId || '').trim().toLowerCase();
        if (!key) {
            throw new TypeError('A support ticket ID is required.');
        }
        if (typeof mutation !== 'function') {
            throw new TypeError('A support ticket mutation callback is required.');
        }

        const previousTail = this.tailsByTicket.get(key) || Promise.resolve();
        const result = previousTail.then(() => mutation());
        const nextTail = result.then(
            () => undefined,
            () => undefined
        );

        this.tailsByTicket.set(key, nextTail);
        nextTail.then(() => {
            if (this.tailsByTicket.get(key) === nextTail) {
                this.tailsByTicket.delete(key);
            }
        });

        return result;
    }
}

export const supportTicketMutationQueue = new SupportTicketMutationQueue();
